import { UserManager } from 'oidc-client';
import AuthConfig from './auth.config';

export default class AuthService {
    constructor() {
        this.client = new UserManager(AuthConfig);
        this.authData = null;

        this.client.events.addAccessTokenExpiring(() => {
            this.silentLogin().catch(() => {
                this.login();
            });
        });

        this.storeUser = this.storeUser.bind(this);
    }

    getUser() {
        return this.client.getUser().then(this.storeUser);
    }

    storeUser(data) {
        this.authData = data;
        return data;
    }

    getAuthData() {
        return this.authData;
    }

    getAccessToken() {
        if (this.authData) {
            return this.authData.access_token;
        }
        return null;
    }

    login() {
        return this.client.signinRedirect();
    }

    silentLogin() {
        return this.client.signinSilent().then(this.storeUser);
    }

    authorize() {
        return this.client.signinRedirectCallback().then(this.storeUser);
    }

    signOut() {
        this.client.signoutRedirect();
    }
}



// WEBPACK FOOTER //
// ./app/services/auth/auth.service.js